import { get, post, put, del } from '@/libs/api.request'
import * as BOM_API from '@/api/bom'

export default {
  state: {
    bomVersions: [],
    bomMain: null,
    bomItems: [],
    CustomerProvided: []
  },
  getters: {
    CustomerProvidedParts: state => {
      return state.CustomerProvided
    }
  },
  mutations: {
    setBomVersions(state, bomVersions) {
      state.bomVersions = bomVersions
    },
    setBomMain(state, bomMain) {
      state.bomMain = bomMain
    },
    setBomItems(state, bomItems) {
      state.bomItems = bomItems
    },
    updateBomItem(state, bomItem) {
      const itemIndex = _.findIndex(state.bomItems, { id: bomItem.id })
      state.bomItems.splice(itemIndex, 1, bomItem)
    },
    addBomItem(state, bomItem) {
      state.bomItems.push(bomItem)
    },
    removeBomItem(state, id) {
      const indx = _.findIndex(state.bomItems, { id: id })
      if (indx > 0) {
        state.bomItems.splice(indx, 1)
      }
    },
    setBoms(state, data) {
      let values = data.reduce((o, item) => {
        o[item.id] = item
        return o
      }, {})
      state.list = Object.assign({}, state.list, values)
    },
    setCustomerProvided(state, value) {
      state.CustomerProvided = value
    }
  },
  actions: {
    getBoms ({ commit }, data) {
      return get(`bom/list`, data).then(res => {
        return res.data
      })
    },
    getBomMain({ commit }, { id, version = null }) {
      let url = `bom/${id}` + (version ? `/version/${version}` : '')

      return get(url).then(resp => {
        commit('setBomMain', resp.data)
        return resp
      })
    },
    getBomItems ({ commit, state }, { id, version }) {
      let url = `bom/${id}` + (version ? `/version/${version}` : '') + `/items`
      return get(url).then(res => {
        commit('setBomItems', res.data)
        return res.data
      })
    },
    getBom ({ commit }, data) {
      return get(`bom/${data.bom_id}`, {
        root_bom_id: data.root_bom_id,
        full_mode: data.full_mode
      }).then(res => {
        commit('setBomMain', res.data.bom)
        return res.data.bom
      })
    },
    getBomByComponent ({ commit }, { componentId, bomType }) {
      return get(`bom/by-component/${componentId}?bom_type=${bomType}`).then(res => {
        commit('setBomTree', res.data)
        return res.data
      })
    },
    // this will be get only single BOM
    getBomByAssemblyPartId ({ commit }, assemblyPartId) {
      return BOM_API.getBomByAssemblyPartId(assemblyPartId)
    },
    // this will be getting all related BOMs
    getBomsByAssemblyPartId ({ commit }, assemblyPartId) {
      return BOM_API.getBomByAssemblyPartId(assemblyPartId, { all: 1 })
    },
    // Todo: remove in v2.2
    getBomWithPartDetail ({ commit }, data) {
      return get(`bom/${data.bom_id}`, {
        full_mode: true
      }).then(res => {
        return res.data.bom
      })
    },
    createBom ({ commit }, data) {
      return post(`bom/create`, data)
    },
    updateBom ({ commit }, data) {
      return put(`bom/${data.id}`, data)
    },
    deleteBom ({ commit }, id) {
      return del(`bom/${id}`)
    },
    getBomVersionsByPorductId ({ commit }, id) {
      return get(`bom/by-product/${id}/versions`).then(res => {
        if (res.data.length === 0) {
          commit('setBomItems', [])
        }

        // Todo: to be compatible with previous code as bomVersions is array
        // the product has actually one single BOM with multiple verions.
        commit('setBomVersions', [res.data])
      })
    },
    getBomTree ({ commit }, id) {
      return get(`bom/${id}/tree`).then(res => {
        commit('setBomTree', res.data)
        return res.data
      })
    },
    getBomSimpleTree ({ commit }, id) {
      return get(`bom/${id}/simple-tree`).then(res => {
        return res.data
      })
    },
    getErpBomTree ({ commit }, { id, max_depth }) {
      return get(`/bom/${id}/erp-bom`, { max_depth: max_depth }).then(res => {
        return res.data
      })
    },
    refreshBomTree({ commit, state, dispatch }, id) {
      commit('setBomTreeActiveId', id)
      // if (!state.bomTree) {
      //   return dispatch('getBomTree', id)
      // }
    },
    searchBom ({ commit }, data) {
      return get(`bom/search`, data)
    },
    migrateBomToErp ({ commit }, data) {
      return post('erp-integration/migrate/bom', data).then(res => {
        return res.data
      })
    },
    syncFromErp ({ commit }, data) {
      return post('bom/sync/from-erp', data)
    },
    // Bom Item
    createBomItem ({ commit }, data) {
      return post('bom/items/create', data).then(resp => {
        commit('addBomItem', resp.data)
        return resp
      })
    },
    updateBomItem ({ commit }, data) {
      return put(`bom/items/${data.id}`, data).then(resp => {
        commit('updateBomItem', resp.data)
        return resp
      })
    },
    deleteBomItem ({ commit }, id) {
      return del(`bom/items/${id}`).then(resp => {
        commit('removeBomItem', id)
        return resp
      })
    },
    uploadBomFile ({ commit }, data) {
      return post(`bom/upload-file`, data)
    },
    getBomItemRevisionsById ({ commit }, id) {
      commit('setLoading', true)
      get(`bom/items/${id}/revisions`).then(res => {
        let bomItemRevisions = _.map(res.data, e => {
          let properties = _.mapValues(e.properties, 'new')
          return {
            changed_by: e.meta.user_name,
            changed_at: e.meta.audit_updated_at,
            ...properties
          }
        })
        commit('setBomItemRevisions', bomItemRevisions)
        commit('setLoading', false)
      })
    },
    moveBomItemSequence ({ commit }, data) {
      return post(`bom/items/sequence`, data)
    },
    getCustomerProvidedByBom ({ commit }, bomId) {
      return BOM_API.getCustomerProvidedByBom(bomId).then(res => {
        commit('setCustomerProvided', res.data)
        return res.data
      })
    },
    runBOMProsecutorChecks ({ commit }, { bomId, checkers, version, partNumber = '' }) {
      return BOM_API.runBOMProsecutor(bomId, checkers, version, partNumber)
    },
    loadPartsFromOctopart ({ commit }, bomId) {
      return BOM_API.loadPartsFromOctopart(bomId).then(res => {
        return res
      })
    }
  }
}
